import type { ContentDetailsAndLoggingDataParams } from "./TestPreparationHelper";

/**
 * Returned by an anonymous saveTest instead of being written to localStorage. Only the login path needs it:
 * its redirect unloads the page, so the caller persists it and checkForAnonymousTests claims the test later.
 */
export interface AnonymousTestHandoff {
    testId: string;
    amplitudeData: ContentDetailsAndLoggingDataParams["amplitudeData"];
}

const TEST_ID_KEY = "anonymousTestId";
const AMPLITUDE_DATA_KEY = "amplitudeData";

export const persistAnonymousTestHandoff = (handoff: AnonymousTestHandoff) => {
    localStorage.setItem(TEST_ID_KEY, handoff.testId);
    localStorage.setItem(AMPLITUDE_DATA_KEY, JSON.stringify(handoff.amplitudeData));
};

const _parseAmplitudeData = () => {
    try {
        return JSON.parse(localStorage.getItem(AMPLITUDE_DATA_KEY) || "{}");
    } catch {
        // A malformed value must not block the claim; the test is still linked, only the event is skipped.
        return {};
    }
};

export const readAnonymousTestHandoff = () => ({
    testId: localStorage.getItem(TEST_ID_KEY) ?? "",
    amplitudeData: _parseAmplitudeData(),
});

// Both keys go together: a leftover "amplitudeData" makes the next claim emit the previous test's payload.
export const clearAnonymousTestHandoff = () => {
    localStorage.removeItem(TEST_ID_KEY);
    localStorage.removeItem(AMPLITUDE_DATA_KEY);
};
